import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const VX_PARAMS_SCHEMA_LITERAL = {
    title: 'Schéma VxParams',
    description: 'Décrit VxParams',
    version: 0,
    keyCompression: false,
    primaryKey: 'CBMARQ',
    type: 'object',
    properties: {
        CBMARQ: { type: 'string', maxLength : 2 },
        VX_QUICKACCESS_ENABLED: { type: 'boolean' },
        VX_QUICKACCESS_PARAMS: { type: 'string' },
        VX_CSTMELEMENTS_ENABLED: { type: 'boolean' },
        VX_CSTMELEMENTS_PARAMS: { type: 'string' },
        VX_MAPANDBOOKING_ENABLED: { type: 'boolean' },
        VX_MAPANDBOOKING_PARAMS: { type: 'string' }
    },
    required: [ 'CBMARQ' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(VX_PARAMS_SCHEMA_LITERAL);
export type RxVxParamsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const VX_PARAMS_SCHEMA: RxJsonSchema<RxVxParamsDocumentType> = VX_PARAMS_SCHEMA_LITERAL;
